@if (incomeTaxEntity$ | async) {
  <form [formGroup]="fromGroup">
    <snelstart-ui-number-form-control [decimals]="0"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="inkomstenSpecifiekeZiektekosten"
                                      id="inkomstenSpecifiekeZiektekosten"
                                      label="Terugontvangen zorgkosten"
                                      prefix="€">
    </snelstart-ui-number-form-control>
    <snelstart-ui-number-form-control [decimals]="0"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="inkomstenOverigGiften"
                                      id="inkomstenOverigGiften"
                                      label="Terugontvangen giften"
                                      prefix="€">
    </snelstart-ui-number-form-control>
    <snelstart-ui-number-form-control [decimals]="0"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="inkomstenOverigStudiekosten"
                                      id="inkomstenOverigStudiekosten"
                                      label="Terugontvangen scholingskosten"
                                      prefix="€">
    </snelstart-ui-number-form-control>
    <snelstart-ui-number-form-control [decimals]="0"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="terugontvangenAlimentatie"
                                      id="terugontvangenAlimentatie"
                                      label="Terugontvangen alimentatie"
                                      prefix="€">
    </snelstart-ui-number-form-control>
  </form>
}
